/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

/**
 * ui-escaper provides a component to enable users to easily escape custom
 * dialogs that don't make use of paper-toolbar.
 */
@classNames('dialog-escaper')
export default class DialogEscaper extends Component {
  // Props
  // onClick provides a callback for when escaping a dialog.
  onClick() {}
}
